import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { loadStaticPageContent } from 'redux/StaticPages/actions';

import { loadInvestFiles } from 'redux/InvestorSection/actions';

import { ssrHandler, isNotEmptyArray } from 'utils';

import InvestorsTemplate from './InvestorsTemplate';

const PAGE_NAME = 'investors';

class Investors extends PureComponent {
  render() {
    if (!this.props.page || !this.props.page.data) {
      return null;
    }
    return (
      <InvestorsTemplate
        content={this.props.page.data}
        files={this.props.files}
      />
    );
  }
}

Investors.propTypes = {
  page: PropTypes.shape({
    data: PropTypes.object,
    isFetching: PropTypes.bool.isRequired
  }),
  files: PropTypes.shape({
    bonds: PropTypes.object
  })
};

const mapStateToProps = (state, props) => {
  return {
    page: state.staticPages.items.find((page) => page.name === PAGE_NAME),
    files: state.investors.files
  };
};

function loadInvestorsData(store, nextState, replace, callback) {
  const { staticPages, investors } = store.getState();
  const page = staticPages.items.find(({ name }) => name === PAGE_NAME);
  const files = investors.files;

  // if (typeof page !== 'undefined' && !isNotEmptyArray(files.bonds.items)) {
  //   return callback();
  // }
  const actions = [loadInvestFiles(), loadStaticPageContent(PAGE_NAME)];
  ssrHandler(store.dispatch, actions, callback);
}

export default (store) => ({
  path: '/we/investors/',
  component: connect(mapStateToProps)(Investors),
  onEnter: loadInvestorsData.bind(null, store)
});



// WEBPACK FOOTER //
// ./src/components/Investors/index.js